import { render } from "./Child.vue?vue&type=template&id=19279b27&scoped=true"
import script from "./Child.vue?vue&type=script&lang=js"
export * from "./Child.vue?vue&type=script&lang=js"

import "./Child.vue?vue&type=style&index=0&id=19279b27&lang=less&scoped=true"

import exportComponent from "E:\\H5\\pay_h5_uni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19279b27"]])

export default __exports__